import { PermissionName } from '@vetahealth/fishing-gear/permissions'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { Users as UserManagementComponent } from '../../components/Widgets/UserManagement'
import { useUserStore } from '../../stores/user'
import { routes } from '.'
import { GenericWrapper } from './styles'

export function UserManagement(): React.ReactNode {
  const navigate = useNavigate()
  const [hasSomePermission] = useUserStore((state) => [state.hasSomePermission])

  useEffect(() => {
    if (!hasSomePermission(PermissionName.manageUser)) {
      navigate(routes.patientList(), { replace: true })
      return
    }
  }, [])

  return (
    <GenericWrapper>
      <UserManagementComponent />
    </GenericWrapper>
  )
}
